<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title class="headline text-uppercase">
        <span>BJAP</span>
        <span class="font-weight-light pl-4">Spendor AI</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        flat
        href="https://github.com/"
        target="_blank"
      >
        <span class="mr-2">Github</span>
      </v-btn>
    </v-toolbar>

    <v-content>
      <Spender/>
    </v-content>
  </v-app>
</template>

<script>
import Spender from './components/Spender';
export default {
  name: 'App',
  components: {
    Spender
  },
  data () {
    return {
      //
    }
  }
}
</script>
